import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import Button from '../common/Button';

const SignatureBox = forwardRef((props, ref) => {
    const sigCanvasRef = useRef<SignatureCanvas>(null);
    const [undoStack, setUndoStack] = useState<Array<any>>([]);

    useImperativeHandle(ref, () => ({
        getSignatureDataUrl: () => sigCanvasRef.current?.toDataURL()
    }));

    const handleClear = () => {
        sigCanvasRef.current?.clear();
        setUndoStack([]);
    };

    const handleUndo = () => {
        if (undoStack.length === 0) return;
        const newStack = [...undoStack];
        newStack.pop(); // remove last stroke
        sigCanvasRef.current?.clear();
        sigCanvasRef.current?.fromData(newStack);
        setUndoStack(newStack);
    };

    const handleEndStroke = () => {
        const data = sigCanvasRef.current?.toData();
        if (data) {
            setUndoStack(data);
        }
    };

    return (
        <div className="border border-gray-300 p-4 rounded-md w-full max-w-md">
            <SignatureCanvas
                ref={sigCanvasRef}
                penColor="black"
                onEnd={handleEndStroke}
                canvasProps={{
                    width: 500,
                    height: 200,
                    className: 'border border-gray-400 rounded-md bg-white w-full',
                }}
            />
            <div className="mt-4 flex justify-end gap-2">
                <Button
                    onClick={handleUndo}
                    variant="secondary"
                >
                    Undo
                </Button>
                <Button
                    onClick={handleClear}
                    variant="secondary"
                >
                    Clear
                </Button>
            </div>
        </div>
    );
});

export default SignatureBox;
